import "./index.css";
import "./translations/i18n";

import { initPortalWebHttpClient } from "@http/httpClientInit";
import { loadGoogleTagManager } from "@lyteflo/utils";
import { initPortalWebDealerContextStore } from "@stores/dealerContextStoreInit";
import { initPortalWebProfileStore } from "@stores/profileStoreInit";
import { initPortalWebTeslaLookupHistoryStore } from "@stores/teslaLookupHistoryStoreInit";
import { isProd, validateEnvVarsExist } from "@utils/environment";
import { initializeManifest } from "@utils/manifest";
import { render } from "preact";

import { App } from "./app";

validateEnvVarsExist();
initPortalWebProfileStore();
initPortalWebDealerContextStore();
initPortalWebTeslaLookupHistoryStore();
initPortalWebHttpClient();
initializeManifest();
loadGoogleTagManager("portal", !isProd);

render(<App />, document.getElementById("app") as HTMLElement);
